import { render, staticRenderFns } from "./ShiftEditDialog.vue?vue&type=template&id=67dee6b9&scoped=true&lang=pug&"
import script from "./ShiftEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditDialog.vue?vue&type=style&index=0&id=67dee6b9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dee6b9",
  null
  
)

export default component.exports